<template>
    <div class="Report__field__content">
        <div
            v-if="submission.data"
            class="Report__group-field-wrapper"
        >
            <div
                class="Report__field__submission"
                v-if="submission.data.testimonial"
            >
                <v-textarea
                    type="text"
                    readonly
                    label="Testimonial"
                    v-model="submission.data.testimonial"
                    dense
                    outlined
                />

                <CopyFieldValue :value="submission.data.testimonial" />
            </div>

            <div
                class="Report__field__submission"
                v-if="submission.data.attestor"
            >
                <v-text-field
                    type="text"
                    readonly
                    label="Name/Location"
                    v-model="submission.data.attestor"
                    dense
                    outlined
                />

                <CopyFieldValue :value="submission.data.attestor" />
            </div>
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';
import CopyFieldValue from '@/reports/Fields/Common/CopyFieldValue';

export default {
    components: { CopyFieldValue },
    mixins: [
        ReportFieldBoilerplate,
    ]
};
</script>
